import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";
const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const CURRENT_YEAR = new Date().getFullYear();

export const ourProjectSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  slug: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .matches(SLUG_PATTERN, {
      message: "Slug may only contain lowercase letters, numbers, and hyphens",
      excludeEmptyString: true,
    }),
  clientId: yup
    .number()
    .typeError("Please select a client")
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
  shortDescription: yup.string().nullable(),
  fullDescription: yup.string().nullable(),
  projectYear: yup
    .number()
    .typeError("Year must be a number")
    .min(1900, "Please enter a valid year")
    .max(CURRENT_YEAR + 5, "Please enter a valid year")
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
  projectUrl: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .url("Please enter a valid URL (e.g. https://example.com)"),
  services: yup.string().nullable(),
  technologies: yup.string().nullable(),
  displayOrder: yup
    .number()
    .typeError("Display order must be a number")
    .min(0, "Display order cannot be negative")
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
});
